import React from 'react';
import { E2E_COMMS_WRAPPER_ID } from '../../../utils/e2eComms.js';

function E2eCommsWrapper() {
  return <div id={E2E_COMMS_WRAPPER_ID} />;
}

export default E2eCommsWrapper;
